import React, {useEffect} from "react";
import {useAuth} from 'util/auth'
import { useDispatch, useSelector } from "react-redux";
import {loadReservations} from 'store/actions/userActions'
import moment from 'moment-timezone'
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Dropdown from 'react-bootstrap/Dropdown'
import SweetAlert from 'react-bootstrap-sweetalert'
import {cancelUserReservation} from 'store/actions/userActions'
import Spinner from 'react-bootstrap/Spinner'
import {apiRequest} from 'util/api/util'
import PaymentMethodSelector from 'components/PaymentMethodSelector'
import CardSection from 'components/CardSection'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { StripeProvider } from 'react-stripe-elements';
import Modal from 'react-bootstrap/Modal'
import NavLink from "react-bootstrap/NavLink";
// import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

moment.locale('en', {
  calendar : {
      lastDay : '[Yesterday]',
      sameDay : '[Today at] LT',
      nextDay : '[Tomorrow at] LT',
      lastWeek : '[last] dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'MMM Do [at] LT'
  }
});

function EditCardSection(props) {

  const [isSaving, setIsSaving] = React.useState(false)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
  const stripe = useStripe()
  const elements = useElements()

  const {isLoading, purchase, checkoutData, ...otherProps} = props

  const onConfirm = async () => {

    setIsSaving(true)

    let paymentMethod = selectedPaymentMethod?.id

    if (!selectedPaymentMethod) {

      const cardElement = elements.getElement(CardElement);

      const paymentMethodReq = await stripe.createPaymentMethod({
          type: 'card',
          card: cardElement
      }, {
          stripeAccount: checkoutData.stripeAccount
      })
      
      if (paymentMethodReq.error?.message) {
          setIsSaving(false)
          window.alert(paymentMethodReq.error.message)
          return
      }
      
      paymentMethod = paymentMethodReq?.paymentMethod?.id
    }

    const body = {
      partnerId: purchase?.offering?.partnerId,
      paymentMethod: paymentMethod
    }

    console.log("POST BODY: ", body)

    apiRequest("app/updateDefaultPaymentMethod", "POST", body)
      .then(response => {
        setIsSaving(false)
        console.log("Great success", response.message)
        if (otherProps?.onConfirm) {
          otherProps.onConfirm(true)
        }
      })
      .catch(err => {
        setIsSaving(false)
        console.log("Stripe update failture: ", err)
        window.alert(err.message)
      })
  }

  return (
                
    <Modal
    disabled={isSaving}
    focusCancelBtn={true}
    onHide={() => props?.onCancel()}
    show={true}
    >
      <Modal.Header closeButton>
        Modify Payment Method
      </Modal.Header>
      <Modal.Body>
        {isLoading && (
          <Spinner
          animation="border"
          size="sm"
          aria-hidden={true}
          className="ml-2"
          >
          </Spinner>
        )}

        {checkoutData?.paymentMethods && (
          <PaymentMethodSelector
            defaultPaymentMethod={checkoutData.defaultPaymentMethod}
            paymentMethods={checkoutData.paymentMethods}
            // paymentMethods={paymentMethods}
            // onChange={(model) => console.log(`got the model: ${model}`)}
            onChange={(model) => {
                setSelectedPaymentMethod(model)
            }}
          />

        )}
        {checkoutData?.stripeAccount && !selectedPaymentMethod && (
          <CardSection className="w-100 mb-5" />
        )}

      </Modal.Body>
      <Modal.Footer>
          {/* <Button  >Cancel</Button> TODO: Success screen */}
          <NavLink disabled={isSaving} onClick={() => props?.onCancel()} className="primaryColor">Cancel</NavLink>
          <Button disabled={isSaving} onClick={onConfirm} type='button' color="primary" className="primaryColor">
            {isSaving && (
              <Spinner
              animation="border"
              size="sm"
              aria-hidden={true}
              className="ml-2"
              >
              </Spinner>
            )}
            Save
          </Button>
          {/* <p style={{fontSize: 'smaller'}}>By entering your email you agree to Sutra's <a href="https://www.sutra.fit/terms">Terms of Service</a> and <a href="https://www.sutra.fit/privacy">Privacy Policy</a></p> */}
      </Modal.Footer>
    </Modal>

  )
}

function PaymentModification(props) {
  const {purchase} = props

  const [checkoutData, setCheckoutData] = React.useState(null)
  const [stripe, setStripe] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {
    setIsLoading(true)
    apiRequest(
      `app/getStripeCustomerProfile`,
      "POST",
      {
        partnerId: purchase?.offering?.partnerId
      })
      .then(response => {
        setCheckoutData(response)

        console.log("RESPONSE: ", response)

        setStripe(window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
          stripeAccount: response.stripeAccount
        }))
        setIsLoading(false)
      })
      .catch(err => {
        window.alert(err)
        console.log("CUSTOMER ERROR: ", JSON.stringify(err))
        setIsLoading(false)
      })
  }, [purchase]);

  const onCancel = () => {
    if (props?.onCancel) {
      props.onCancel()
    }
  }

  const onConfirm = (response) => {
    if (props?.onConfirm) {
      props.onConfirm(response)
    }
  }

  return (
    <StripeProvider stripe={stripe} >
      <Elements stripe={stripe} >
        <EditCardSection 
        isLoading={isLoading}
        purchase={purchase}
        checkoutData={checkoutData}
        onConfirm={onConfirm}
        onCancel={onCancel}
        />
      </Elements>
    </StripeProvider>
  )
}

function SubscriptionCancellation(props) {

  const {purchase} = props

  const [isSaving, setIsSaving] = React.useState(false)

  const onConfirm = () => {

    setIsSaving(true)
    apiRequest(
      `clients/purchases?clientId=${purchase.userId}&purchaseId=${purchase?.id ?? ""}`,
      "PUT",
      {purchase: {
        canceled: true,
        id: purchase?.id ?? ""
      }})
      .then(updatedPurchase => {
          if (props?.onConfirm) {
            props.onConfirm({
              ...purchase,
              ...updatedPurchase
            })
          }
          setIsSaving(false)
      })
      .catch(err => {
          console.log(err)
          setIsSaving(false)
          // onFinished()
          window.alert("something went wrong updating")

      })

    // if (props?.onConfirm) {
    //   props.onConfirm()
    // }
  }

  const onCancel = () => {
    if (props?.onCancel) {
      props.onCancel()
    }
  }

  return (
    <SweetAlert 
    style={{marginTop: "100px"}}
      disabled={isSaving}
      showCancel={!isSaving}
      title={`Are you sure you'd like to cancel?`}
      confirmBtnText="Yes"
      cancelBtnText="No"
      confirmBtnBsStyle="link"
      focusCancelBtn={true}
      onConfirm={() => onConfirm()}
      onCancel={() => onCancel()}
    >
      {isSaving && (

        <Spinner
        animation="border"
        size="sm"
        aria-hidden={true}
        className="ml-2"
      >
        <span className="sr-only">Loading</span>
      </Spinner>
      )}
      If you cancel this subscription your access will expire on {moment(purchase.expires * 1000).format("l")}.
    </SweetAlert>
  )
}

function PurchaseCard({purchase, ...otherProps}) {

    const [alert, setAlert] = React.useState(null)

    const expiration = moment(purchase.expires * 1000)

    let subtitle = ""
    switch (purchase.offering.type) {
    case 'pack':
        // subtitle = "Blah"
        subtitle = `${purchase.remaining} remaining`
        if (purchase.offering.expires) {
          subtitle = subtitle +  ` • expires ${expiration.format('l')}`
        }
        break
    case 'subscription':
        // subtitle = "Blooh"
        if (purchase.canceled) {
          subtitle = `Expires ${expiration.format('l')}`
        } else {
          subtitle = `Renews ${expiration.format('l')}`
        }

        if (purchase?.offering?.subscriptionType === 'limited') {
          subtitle = `${purchase.remaining} remaining • ` + subtitle
        }
        
        break
    }

    const descriptionHtml = purchase?.offering?.descriptionHTML ? htmlToReactParser.parse(purchase.offering.descriptionHTML) : null;
    const viewModel = {
        name: purchase.offering.name,
        // subtitle: "Expires " + expiration.format('l'),
        canceled: purchase?.offering?.type === "subscription" ? purchase?.canceled : false,
        cancelable: purchase?.offering?.type === "subscription",
        subtitle: subtitle,
        partnerName: "With " + purchase.partner.firstName,
        description: descriptionHtml ? descriptionHtml : ((purchase.offering.description && purchase.offering.description !== "") ? purchase.offering.description : "None")
    }
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
          href=""
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
        </a>
    ));

    function handleCancel() {
      setAlert(<SubscriptionCancellation 
        purchase={purchase}
        onConfirm={(updatedPurchase) => {
          if (otherProps.updatedPurchase) {
            otherProps.updatedPurchase(updatedPurchase)
          }
          setAlert(false)
        }}
        onCancel={() => setAlert(false)}
      />)
    }

    function handleModify() {
      setAlert(
        <PaymentModification 
        purchase={purchase}
        onConfirm={(response) => {
          setAlert(false)
          if (response) {
            setAlert(
              <SweetAlert success timeout={1000} onConfirm={() => setAlert(false)} >
              </SweetAlert>
            )
            // window.alert("great success")
          }
        }}
        onCancel={() => setAlert(false)}
      />)
    }

    return (
        <Card disabled={true} border='white' className='text-left p-0' style ={{width: '100%'}}>
          {alert}
          <Accordion>
          <Card.Body className='p-1'>
            <div className='d-flex flex-row align-items-center justify-content-between'>
              <div className='d-flex flex-row align-items-center'>
                {/* <div style={{height: '80px', width: '80px'}} className="mr-3">
                    <Image src={viewModel.image} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
                </div> */}
                <div>
                  <Card.Title className='mb-1'>
                    {viewModel.name} 
                    {/* {viewModel.remaining && (
                        <span className="_danger">&nbsp;({viewModel.remaining})</span>
                    )} */}
                    {viewModel.canceled && (
                      <span className="_danger">&nbsp;(Canceled)</span>
                    )}
                  </Card.Title>
                  <Card.Text style={{color: 'gray'}} className="m-0 p-0">
                    {viewModel.subtitle}
                  </Card.Text>
                  
                  <Card.Text style={{color: 'gray'}} className="m-0 p-0 font-weight-bold">
                      {viewModel.partnerName}
                  </Card.Text>
                  <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                      View Details
                  </Accordion.Toggle>
                </div>
                
              </div>
              {false ? (
                <Spinner
                animation="border"
                size="sm"
                aria-hidden={true}
                className="ml-2"
                />
              ) : (
                <>
                {viewModel.cancelable && (
                  <Dropdown>
                    <Dropdown.Toggle  as={CustomToggle} id="dropdown-basic">
                      <MoreHorizIcon className="primaryColor" />
                    </Dropdown.Toggle>
      
                    <Dropdown.Menu>
                      
                        <Dropdown.Item className="primaryColor" onClick={() => {
                          handleModify()
                        }}>Modify</Dropdown.Item>
      
                      {viewModel.cancelable && !viewModel.canceled && (
                        <Dropdown.Item className="primaryColor" onClick={() => {
                            handleCancel()
                        }}>Cancel</Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                  )}
                </>
              )}
    
            </div>
            <div>
                <Accordion.Collapse eventKey="0">
                  <Card.Text>
                    {viewModel.description}
                  </Card.Text>
                </Accordion.Collapse>
            </div>
          </Card.Body>
          
          </Accordion>
    
          <hr />
        </Card>
    )
}

// Users bookings with the ability to cancel
function PurchasesSection() {

    const auth = useAuth()
    const dispatch = useDispatch()

    const [purchases, setPurchases] = React.useState([])

    const updatedPurchase = (purchase) => {
      var copyOfPurchases = [...purchases]
      const index = copyOfPurchases.findIndex(val => val.id === purchase.id)
      if (index !== -1) {
          copyOfPurchases[index] = purchase
      }

      setPurchases(copyOfPurchases)
    }

    useEffect(() => {
        if (auth.userData) {
        //   dispatch(loadReservations(auth.userData))
            apiRequest("app/purchases")
                .then(updated => {
                    // console.log(updated)
                    setPurchases(updated)
                })

        }
        
    }, [dispatch, auth.userData])

    return (
    <>
    <section>
        <h3 className="font-weight-bold">Purchases</h3>
        {purchases.map((element, index) => {
            return <PurchaseCard updatedPurchase={updatedPurchase} key={index} purchase={element} />
            // return <h6 key={index}>{element.offering.name}</h6>
        })}
        {/* {upcomingReservations.map(element => {
        return <ReservationCard key={element.id} reservation={element} />
        // return (<li key={element.id}>{moment(element.objectSnapshot.start_time * 1000).format("LLL")}</li>)
        })} */}

    </section>
        
    </>
    );
}

export default PurchasesSection;